import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import UserLogin from './pages/UserLogin';
import AdminLogin from './pages/AdminLogin';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';

// Games
import DeductiveGame from './components/Games/DeductiveGame';
import InductiveGame from './components/Games/InductiveGame';
import SwitchGame from './components/Games/SwitchGame';
import GridGame from './components/Games/GridGame';
import MotionGame from './components/Games/MotionGame';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<UserLogin />} />
          <Route path="/admin" element={<AdminLogin />} />

          {/* Protected User Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <UserDashboard />
              </ProtectedRoute>
            }
          />

          {/* Protected Admin Routes */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Game Routes (Open in New Tab) */}
          <Route path="/game/deductive" element={<DeductiveGame />} />
          <Route path="/game/inductive" element={<InductiveGame />} />
          <Route path="/game/switch" element={<SwitchGame />} />
          <Route path="/game/grid" element={<GridGame />} />
          <Route path="/game/motion" element={<MotionGame />} />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
